/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent, HTMLAttributes } from 'react'
import { styles } from './styles'

interface MessageProps extends HTMLAttributes<HTMLDivElement> {
  type: 'info' | 'error' | 'success'
}

export const Message: FunctionComponent<MessageProps> = ({ type, ...props }) => (
  <div css={[styles.base, styles[type]]} {...props} />
)
